import { Text } from "../Typography/Text.js";
import MenuTitle_module_default from "./MenuTitle.module.js";
import classNames from "classnames";
import "react";
import { jsx } from "react/jsx-runtime";
//#region src/components/Menu/MenuTitle.tsx
var MenuTitle = ({ title, id, className }) => {
	return /* @__PURE__ */ jsx(Text, {
		as: "h3",
		id,
		className: classNames(MenuTitle_module_default["menu-title"], className),
		size: "sm",
		weight: "semibold",
		children: title
	});
};
//#endregion
export { MenuTitle };

//# sourceMappingURL=MenuTitle.js.map